import React from "react";

function G5() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="326"
      height="26"
      fill="none"
      viewBox="0 0 326 26"
    >
      <path
        fill="#80FF00"
        fillRule="evenodd"
        d="M0 .688h175.793l24.34 24.34h125.588v.811H199.797L175.457 1.5H0V.688z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}

export default G5;